import { useEffect, useState } from "react"
import { countMaxPeopleInSubscription, countRemainingBeneficiairy, deleteBeneficiairy, fetchBeneficiairyUsers } from "../../HTTP/subscription"
import { tailwindClassForColoredButton } from "../../Helper/utils"
import ListElementsMobile from "../Admin/ListElementsMobile"
import TableElements from "../Admin/TableElements"
import AddBeneficiaryPopup from "./AddBeneficiaryPopup"

export default function BeneficiaryManagement() {
    const user = JSON.parse(localStorage.getItem('user'))
    const userId = user.id
    const [beneficiaries, setBeneficiaries] = useState([])
    const [maxPeople, setMaxPeople] = useState(-1)
    const [remainingBeneficiairy, setRemainingBeneficiairy] = useState(-1)
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const [callAPIDone, setCallAPIDone] = useState(false)
    const [change, setChange] = useState(false)

    useEffect(() => {
        const fetchMaxPeople = async () => {
            const res = await countMaxPeopleInSubscription(userId)
            setMaxPeople(res.max)
        }
        fetchMaxPeople()

        const fetchRemainingBeneficiairy = async () => {
            const res = await countRemainingBeneficiairy(userId)
            setRemainingBeneficiairy(res.remaining)
        }
        fetchRemainingBeneficiairy()

        const fetchBeneficiaries = async () => {
            const res = await fetchBeneficiairyUsers(userId)
            setBeneficiaries(res)
        }
        fetchBeneficiaries()

        setCallAPIDone(true)
    }, [change, userId])

    // Fonction pour ouvrir/fermer la popup
    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen)
    }

    const handleDeleteBeneficiary = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce bénéficiaire?")) {
            try {
                const remove = await deleteBeneficiairy(parseInt(id), userId)
                if (remove) {
                    setChange(!change)
                }
            } catch (error) {
                console.error("Erreur lors de la suppression du bénéficiaire:", error)
                alert("Une erreur est survenue lors de la suppression du bénéficiaire")
            }
        }
    }

    if (!callAPIDone || maxPeople <= 0) {
        return null
    }

    return (
        <>
            <div className="flex-grow">
                <h2 className="text-center mt-8 text-2xl font-bold">
                    Gestion bénéficiaires
                </h2>
                {
                    remainingBeneficiairy > 0 && (
                        <button
                            className={tailwindClassForColoredButton("green") + " mt-4 mb-4 ml-8"}
                            onClick={togglePopup}
                        >
                            {`Ajouter un bénéficiaire (${remainingBeneficiairy} restants)`}
                        </button>
                    )
                }
                {
                    (
                        <>
                        <div className="hidden xl:block ml-8 mr-8">
                            <TableElements 
                                columns={[
                                    {props:'lastname',display:"Nom"},
                                    {props:'firstname',display:"Prénom"},
                                    {props:'email',display:"Email"},
                                    {props:'',display:"Actions"}
                                ]}
                                data={beneficiaries}
                                buttons={[{display:'Supprimer',action:handleDeleteBeneficiary, color:'red', props:'id'}]}
                                />
                        </div>
                        <div className="xl:hidden w-full px-4 space-y-4">
                            <ListElementsMobile
                                columns={[
                                    {props:'lastname',display:"Nom"},
                                    {props:'firstname',display:"Prénom"},
                                    {props:'email',display:"Email"},
                                    {props:'',display:"Actions"}
                                ]}
                                data={beneficiaries}
                                buttons={[{display:'Supprimer',action:handleDeleteBeneficiary, color:'red', props:'id'}]}
                            />
                        </div>
                        </>
                    )
                }
            </div>

            <AddBeneficiaryPopup 
                isOpen={isPopupOpen} 
                onClose={togglePopup}
                change={change}
                onChange={setChange}
                userId={userId}
            />
        </>
    )
}